module.exports = __webpack_public_path__ + "static/img/jiankangcover.9d95bce5.png";